require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bic-calls-on-the-world-bank-and-african-development.json") })
        }
      }, "path---en-us-update-bic-calls-on-the-world-bank-and-african-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bic-calls-on-the-world-bank-and-african-development!./.cache/json/en-us-update-bic-calls-on-the-world-bank-and-african-development.json
// module id = 624
// module chunks = 231608221292675